import React, { useState, useEffect } from 'react'
import PageHeader from '../../../components/PageHeader/PageHeader'
import {
  Modal,
  Button,
  Menu,
  Segment,
  Form,
  Message,
  Icon,
  Header,
  Grid,
  Label,
  Progress,
} from 'semantic-ui-react'
import MickeyForm from '../../../components/Forms/MickeyForm'
import { useNavigate } from 'react-router-dom'
import env from '../../../env'
import { useSelector } from 'react-redux'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import MickeyDropdown from '../../../components/MickeyDropdown/MickeyDropdown'
import { Table } from 'semantic-ui-react'
import AdminProductVariants from './AdminProductVariants'
import ProductAgentChat from '../../../components/ProductAgentChat/ProductAgentChat'
import {
  PencilLine,
  Trash,
  Upload,
  FileArrowUp,
  FilePdf,
  FileXls,
  FileImage,
  FileText,
} from 'phosphor-react'
import useAxios from '../../../lib/auth/useAxios'
function AdminProducts({ navigation }) {
  const axios = useAxios()
  const [reload, setReload] = useState(false)
  const [update, setUpdate] = useState(false)
  const [openAddProductModal, setOpenAddProductModal] = useState(false)
  const [openAddConversionModal, setOpenAddConversionModal] = useState(false)
  const [editProductModal, setEditProductModal] = useState(false)
  const [editConversionModal, setEditConversionModal] = useState(false)
  const [activeTab, setActiveTab] = useState('products')

  // Jobs state
  const [jobs, setJobs] = useState([])
  const [jobsLoading, setJobsLoading] = useState(false)
  const [selectedJob, setSelectedJob] = useState(null)

  // Import modal states
  const [openImportModal, setOpenImportModal] = useState(false)
  const [importFile, setImportFile] = useState(null)
  const [importContext, setImportContext] = useState('')
  const [importLoading, setImportLoading] = useState(false)
  const [importPreview, setImportPreview] = useState(null)
  const [importError, setImportError] = useState(null)
  const [importSuccess, setImportSuccess] = useState(null)
  const [validationStep, setValidationStep] = useState(null)
  const [validationFeedback, setValidationFeedback] = useState(null)

  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedConversion, setSelectedConversion] = useState(null)
  const [showAgentChat, setShowAgentChat] = useState(false)
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const [openAddOrderModal, setOpenAddOrderModal] = useState(null)
  const navigate = useNavigate()

  // Auto-refresh jobs when on jobs tab
  useEffect(() => {
    let interval

    if (activeTab === 'jobs') {
      // Initial fetch
      fetchJobs()

      // Set up polling every 3 seconds for active jobs
      interval = setInterval(async () => {
        try {
          // Only fetch if there are active jobs
          if (
            jobs.some((job) =>
              ['processing', 'validating', 'improving'].includes(job.status)
            )
          ) {
            await fetchJobs()
          }
        } catch (error) {
          // Stop polling on authentication errors
          if (
            error.response?.status === 401 ||
            error.response?.status === 403
          ) {
            console.error('Authentication error, stopping job polling')
            clearInterval(interval)
          }
        }
      }, 3000)
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [activeTab]) // Removed 'jobs' from dependencies to prevent re-runs

  const handleTabChange = (e, { name }) => {
    setActiveTab(name)
    if (name === 'jobs') {
      fetchJobs()
    }
  }

  const fetchJobs = async () => {
    setJobsLoading(true)
    try {
      const response = await axios.get('main/ingestion-jobs/')
      setJobs(response.data.results)
    } catch (error) {
      console.error('Failed to fetch jobs:', error)
    } finally {
      setJobsLoading(false)
    }
  }

  const fetchJobStatus = async (jobId) => {
    try {
      const response = await axios.get(`main/ingestion-jobs/${jobId}/`)
      return response.data
    } catch (error) {
      console.error('Failed to fetch job status:', error)
      return null
    }
  }

  const cancelJob = async (jobId) => {
    try {
      await axios.post(`main/ingestion-jobs/${jobId}/cancel/`)
      fetchJobs()
    } catch (error) {
      console.error('Failed to cancel job:', error)
    }
  }

  const headerSearch = [
    {
      header: 'Product Name',
      type: 'search',
      input_type: 'text',
      search_param: 'product__material__name',
    },
    {
      header: 'Commodity',
      type: 'search',
      input_type: 'text',
      search_param: 'product__commodity__name',
    },
    {
      header: 'Commodity Form',
      type: 'search',
      input_type: 'text',
      search_param: 'product__commodity_form__name',
    },
  ]
  const headerSort = [
    {
      header: 'Product Name',
      sort_by: 'product__material__name',
    },
    {
      header: 'Commodity',
      sort_by: 'product__commodity__name',
    },
    {
      header: 'Commodity Form',
      sort_by: 'product__commodity_form__name',
    },
  ]

  const headerRow = ['Product Name', 'Commodity Form', 'Commodity', '']

  // Conversion table configuration
  const conversionHeaderRow = ['From Unit', 'To Unit', 'Conversion Rate', '']

  async function deleteProduct(productId) {
    if (!window.confirm('Are you sure you want to delete this product?')) {
      return
    }
    try {
      await axios.delete(`/main/products/${productId}/`)
      setReload(true)
      setSelectedProduct(null)
    } catch (error) {
      console.error('Error deleting product:', error)
      alert('Failed to delete product: ' + (error.response?.data?.detail || error.message))
    }
  }

  function deleteConversion(e, d) {}

  // Import functions
  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setImportFile(file)
      setImportError(null)
    }
  }

  const handleImportPreview = async () => {
    console.log('🔄 handleImportPreview called')
    if (!importFile) {
      setImportError('Please select a file')
      return
    }

    setImportLoading(true)
    setImportError(null)

    const formData = new FormData()
    formData.append('import_file', importFile)
    formData.append('use_ai_extraction', 'true')
    formData.append('action', 'preview')
    formData.append('async', 'true') // Enable async mode
    if (importContext) {
      formData.append('context', importContext)
    }

    console.log(
      '📤 Sending POST request to main/products/import/ with async=true'
    )
    console.log('📋 FormData contents:', {
      filename: importFile.name,
      filesize: importFile.size,
      use_ai_extraction: 'true',
      action: 'preview',
      async: 'true',
      context: importContext || 'none',
    })

    try {
      const response = await axios.post('main/products/import/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log('✅ Received response:', response.data)

      // Check if we got a job response (async mode) or preview data
      if (response.data.job_id) {
        // Async mode - job created
        console.log(
          '🎯 Async mode detected - job created with ID:',
          response.data.job_id
        )
        setOpenImportModal(false)
        setImportFile(null)
        setImportContext('')
        setActiveTab('jobs')
        fetchJobs()

        // Show success message
        setImportSuccess({
          message: 'File uploaded successfully! Processing in background...',
        })
        setTimeout(() => setImportSuccess(null), 5000)
      } else {
        // Sync mode - preview data
        console.log('🔄 Sync mode detected - preview data received')
        setImportPreview(response.data)
      }
    } catch (error) {
      console.error('❌ Error in handleImportPreview:', error)
      console.error('❌ Error response:', error.response?.data)
      setImportError(error.response?.data?.error || 'Failed to preview file')
    } finally {
      setImportLoading(false)
    }
  }

  const handleValidateProducts = async () => {
    if (!importPreview?.products) {
      setImportError('No products to validate')
      return
    }

    setImportLoading(true)
    setImportError(null)
    setValidationStep('validating')

    try {
      const response = await axios.post('main/products/import/', {
        action: 'validate',
        products_data: JSON.stringify(importPreview.products),
        context: importContext,
      })

      setValidationFeedback(response.data)
      setValidationStep('feedback')
    } catch (error) {
      setImportError(
        error.response?.data?.error || 'Failed to validate products'
      )
      setValidationStep(null)
    } finally {
      setImportLoading(false)
    }
  }

  const handleImproveExtraction = async () => {
    if (!validationFeedback) {
      return
    }

    setImportLoading(true)
    setImportError(null)
    setValidationStep('improving')

    try {
      // We need to save the file content for improvement
      // For now, we'll just pass the current products and feedback
      const response = await axios.post('main/products/import/', {
        action: 'improve',
        products_data: JSON.stringify(importPreview.products),
        validation_feedback: validationFeedback,
        context: importContext,
        file_content: '', // In a real implementation, we'd store this from the preview step
      })

      setImportPreview(response.data)
      setValidationStep(null)
      setValidationFeedback(null)
    } catch (error) {
      setImportError(
        error.response?.data?.error || 'Failed to improve extraction'
      )
    } finally {
      setImportLoading(false)
    }
  }

  const handleImportConfirm = async () => {
    if (!importPreview?.products) {
      setImportError('No products to import')
      return
    }

    setImportLoading(true)
    setImportError(null)

    try {
      const response = await axios.post('main/products/import/', {
        action: 'import',
        products_data: JSON.stringify(importPreview.products),
      })

      setImportSuccess(response.data)
      setImportPreview(null)
      setImportFile(null)
      setReload(true)

      // Close modal after a delay
      setTimeout(() => {
        setOpenImportModal(false)
        setImportSuccess(null)
      }, 3000)
    } catch (error) {
      setImportError(error.response?.data?.error || 'Failed to import products')
    } finally {
      setImportLoading(false)
    }
  }

  const getFileIcon = (fileName) => {
    const ext = fileName?.toLowerCase().split('.').pop()
    switch (ext) {
      case 'pdf':
        return <FilePdf size={24} />
      case 'xlsx':
      case 'xls':
      case 'csv':
        return <FileXls size={24} />
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        return <FileImage size={24} />
      default:
        return <FileText size={24} />
    }
  }

  return (
    <>
      <div className={'main-container'}>
        <PageHeader
          buttons={[
            {
              color: 'primary',
              hidden: activeTab !== 'products',
              content: 'Add Product',
              onClick: () => {
                setOpenAddProductModal(true)
              },
              style: {
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              },
            },
            {
              color: 'purple',
              hidden: activeTab !== 'products',
              content: showAgentChat ? 'Hide AI Assistant' : 'AI Assistant',
              icon: <Icon name="robot" />,
              onClick: () => {
                setShowAgentChat(!showAgentChat)
              },
              style: {
                '--primaryColor': '#9b59b6',
                '--secondaryButtonColor': '#8e44ad',
              },
            },
            {
              color: 'secondary',
              hidden: activeTab !== 'products',
              content: 'Import Products',
              icon: <Upload weight="bold" />,
              onClick: () => {
                setOpenImportModal(true)
                setImportError(null)
                setImportSuccess(null)
                setImportPreview(null)
                setImportContext('')
                setValidationStep(null)
                setValidationFeedback(null)
              },
              style: {
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              },
            },
            {
              color: 'primary',
              hidden: activeTab !== 'conversions',
              content: 'Add Conversion',
              onClick: () => {
                setOpenAddConversionModal(true)
              },
              style: {
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              },
            },
          ]}
        />
        <Menu attached="top" tabular>
          <Menu.Item
            name="products"
            active={activeTab === 'products'}
            onClick={handleTabChange}
          >
            Products & Variants
          </Menu.Item>
          <Menu.Item
            name="conversions"
            active={activeTab === 'conversions'}
            onClick={handleTabChange}
          >
            Conversions
          </Menu.Item>
          <Menu.Item
            name="jobs"
            active={activeTab === 'jobs'}
            onClick={handleTabChange}
          >
            Import Jobs
            {jobs.filter((j) => j.status === 'processing').length > 0 && (
              <Label color="blue" size="mini" style={{ marginLeft: 8 }}>
                {jobs.filter((j) => j.status === 'processing').length}
              </Label>
            )}
          </Menu.Item>
        </Menu>

        {showAgentChat && activeTab === 'products' && (
          <Segment style={{ marginBottom: '20px' }}>
            <Header as="h3" style={{ marginBottom: '15px' }}>
              <Icon name="robot" color="purple" />
              <Header.Content>
                AI Product Assistant
                <Header.Subheader>
                  Create products, add attributes, and manage your catalog with natural language
                </Header.Subheader>
              </Header.Content>
            </Header>
            <ProductAgentChat onProductsCreated={() => setReload(!reload)} />
          </Segment>
        )}

        {activeTab === 'products' && (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '100%',
            }}
          >
            <MickeyTable
              style={{ flex: '0 0 30%' }}
              headerRow={headerRow}
              headerSearch={headerSearch}
              headerSort={headerSort}
              basicSegment
              showHeaderNoData={true}
              url={'/main/products/'}
              hideFooter={false}
              reload={reload}
              setReload={setReload}
              renderBodyRow={(data, index) => {
                return (
                  <Table.Row
                    onClick={() => setSelectedProduct(data)}
                    positive={selectedProduct?.id === data?.id}
                    key={data.id}
                  >
                    <Table.Cell width={1}>
                      <p>{data?.material?.name} </p>
                    </Table.Cell>
                    <Table.Cell width={1}>
                      <p>{data?.commodity_form?.name}</p>
                    </Table.Cell>
                    <Table.Cell width={1}>
                      <p>{data?.commodity?.name}</p>
                    </Table.Cell>
                    <Table.Cell width={2}>
                      <Button.Group size={'mini'}>
                        <Button
                          circular
                          size={'mini'}
                          icon={<PencilLine />}
                          onClick={() => {
                            setEditProductModal(true)
                          }}
                        ></Button>
                        <Button
                          circular
                          color="red"
                          size={'mini'}
                          icon={<Trash />}
                          onClick={() => {
                            deleteProduct(data.id)
                          }}
                        ></Button>
                      </Button.Group>
                    </Table.Cell>
                  </Table.Row>
                )
              }}
              emptyIcon={'file'}
              emptyMessage={'Your products will populate here'}
            />
            <div
              style={{
                backgrounColor: 'red',
                width: '100%',
                height: '100%',
                flex: '0 0 70%',
              }}
            >
              <AdminProductVariants product={selectedProduct} />
            </div>
          </div>
        )}

        {activeTab === 'conversions' && (
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <MickeyTable
              headerRow={conversionHeaderRow}
              basicSegment
              showHeaderNoData={true}
              url={'/main/conversions/'}
              hideFooter={false}
              reload={reload}
              setReload={setReload}
              emptyIcon={'exchange'}
              emptyMessage={'Your product conversions will populate here'}
              renderBodyRow={(data, index) => {
                return (
                  <Table.Row
                    onClick={() => setSelectedProduct(data)}
                    positive={selectedProduct?.id === data?.id}
                    key={data.id}
                  >
                    <Table.Cell width={1}>
                      <p>{data?.from_unit?.singular_name}</p>
                    </Table.Cell>
                    <Table.Cell width={1}>
                      <p>{data?.to_unit?.singular_name}</p>
                    </Table.Cell>
                    <Table.Cell width={1}>
                      <p>{data?.multiplier}</p>
                    </Table.Cell>
                    <Table.Cell width={2}>
                      <Button.Group size={'mini'}>
                        <Button
                          circular
                          size={'mini'}
                          icon={<PencilLine />}
                          onClick={() => {
                            setEditConversionModal(true)
                            setSelectedConversion(data)
                          }}
                        ></Button>
                        <Button
                          circular
                          color="red"
                          size={'mini'}
                          icon={<Trash />}
                          onClick={() => {
                            deleteConversion(data.id)
                          }}
                        ></Button>
                      </Button.Group>
                    </Table.Cell>
                  </Table.Row>
                )
              }}
            />
          </div>
        )}

        {activeTab === 'jobs' && (
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <MickeyTable
              headerRow={[
                'Job Name',
                'Status',
                'Progress',
                'Products',
                'Created',
                'Duration',
                '',
              ]}
              basicSegment
              showHeaderNoData={true}
              data={jobs}
              loading={jobsLoading}
              hideFooter={false}
              emptyIcon={'clock'}
              emptyMessage={'No import jobs yet'}
              renderBodyRow={(job, index) => {
                const getStatusColor = (status) => {
                  switch (status) {
                    case 'completed':
                      return 'green'
                    case 'failed':
                      return 'red'
                    case 'processing':
                      return 'blue'
                    case 'validating':
                      return 'orange'
                    case 'improving':
                      return 'yellow'
                    case 'cancelled':
                      return 'grey'
                    default:
                      return null
                  }
                }

                const formatDuration = (duration) => {
                  if (!duration) return '-'
                  // Parse duration string (format: "0:01:23.456789")
                  const match = duration.match(/(\d+):(\d+):(\d+)/)
                  if (match) {
                    const hours = parseInt(match[1])
                    const minutes = parseInt(match[2])
                    const seconds = parseInt(match[3])
                    if (hours > 0) return `${hours}h ${minutes}m`
                    if (minutes > 0) return `${minutes}m ${seconds}s`
                    return `${seconds}s`
                  }
                  return duration
                }

                return (
                  <Table.Row
                    key={job.job_id}
                    onClick={() => setSelectedJob(job)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Table.Cell>
                      <p>{job.name}</p>
                      <small style={{ color: '#666' }}>{job.file_name}</small>
                    </Table.Cell>
                    <Table.Cell>
                      <Label color={getStatusColor(job.status)} size="small">
                        {job.status}
                      </Label>
                    </Table.Cell>
                    <Table.Cell>
                      {job.status === 'processing' ||
                      job.status === 'validating' ||
                      job.status === 'improving' ? (
                        <Progress
                          percent={job.progress}
                          size="tiny"
                          color={getStatusColor(job.status)}
                          style={{ margin: 0 }}
                        />
                      ) : (
                        <span>{job.progress}%</span>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {job.products_created > 0 && (
                        <Label size="tiny" basic>
                          <Icon name="box" />
                          {job.products_created}
                        </Label>
                      )}
                      {job.validation_score && (
                        <Label
                          size="tiny"
                          basic
                          color={
                            job.validation_score >= 80 ? 'green' : 'orange'
                          }
                        >
                          <Icon name="check" />
                          {job.validation_score}%
                        </Label>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {new Date(job.created_at).toLocaleString()}
                    </Table.Cell>
                    <Table.Cell>{formatDuration(job.duration)}</Table.Cell>
                    <Table.Cell>
                      {job.status === 'processing' && (
                        <Button
                          size="mini"
                          color="red"
                          onClick={(e) => {
                            e.stopPropagation()
                            cancelJob(job.job_id)
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                      {job.status === 'completed' && (
                        <Button
                          size="mini"
                          primary
                          onClick={(e) => {
                            e.stopPropagation()
                            // View products - could open a modal or navigate
                            fetchJobStatus(job.job_id).then((data) => {
                              if (data && data.products) {
                                setImportPreview({
                                  file_name: job.file_name,
                                  products_found: data.products_count,
                                  products: data.products,
                                  validation_score: data.validation_score,
                                })
                              }
                            })
                          }}
                        >
                          View
                        </Button>
                      )}
                    </Table.Cell>
                  </Table.Row>
                )
              }}
            />
          </div>
        )}
      </div>
      <Modal
        onClose={() => setOpenAddProductModal(false)}
        onOpen={() => setOpenAddProductModal(true)}
        open={openAddProductModal}
      >
        <Modal.Header>Add a Product</Modal.Header>
        <Modal.Content>
          <MickeyForm
            formName={'ProductForm'}
            model={'Product'}
            reload={reload}
            setReload={setReload}
            buttonFloatedRight={true}
            successMessage={'Product Added!'}
            addToSubmit={() => {
              setOpenAddProductModal(false)
              setReload(true)
            }}
            failureMessage={'Error adding product.'}
            url={'/main/products/'}
          />
        </Modal.Content>
      </Modal>
      <Modal
        onClose={() => setEditProductModal(false)}
        onOpen={() => setEditProductModal(true)}
        open={editProductModal}
      >
        <Modal.Header>
          Edit {selectedProduct?.material?.name} (
          {selectedProduct?.commodity_form?.name})
        </Modal.Header>
        <Modal.Content>
          <MickeyForm
            formName={'ProductForm'}
            model={'Product'}
            reload={reload}
            instanceId={selectedProduct?.id}
            setReload={setReload}
            buttonFloatedRight={true}
            url={'/main/products/'}
          />
        </Modal.Content>
      </Modal>
      <Modal
        onClose={() => setEditConversionModal(false)}
        onOpen={() => setEditConversionModal(true)}
        open={editConversionModal}
      >
        <Modal.Header>
          Edit {selectedConversion?.from_unit?.singular_name} to
          {selectedConversion?.to_unit?.singular_name}
        </Modal.Header>
        <Modal.Content>
          <MickeyForm
            formName={'ConversionForm'}
            model={'Conversion'}
            reload={reload}
            instanceId={selectedConversion?.id}
            setReload={setReload}
            buttonFloatedRight={true}
            url={'/main/conversions/'}
          />
        </Modal.Content>
      </Modal>

      {/* Import Modal */}
      <Modal
        onClose={() => {
          setOpenImportModal(false)
          setImportFile(null)
          setImportContext('')
          setImportPreview(null)
          setImportError(null)
          setImportSuccess(null)
          setValidationStep(null)
          setValidationFeedback(null)
        }}
        onOpen={() => setOpenImportModal(true)}
        open={openImportModal}
        size="large"
      >
        <Modal.Header>
          <Icon name="upload" />
          Import Products from File
        </Modal.Header>
        <Modal.Content scrolling>
          {!importPreview && !importSuccess && (
            <>
              <Segment>
                <Header icon>
                  <Icon name="file outline" />
                  Upload any file containing product information
                </Header>
                <p>
                  Our AI will intelligently extract products, attributes, and
                  specifications from:
                </p>
                <Grid columns={4} stackable textAlign="center">
                  <Grid.Column>
                    <FilePdf
                      size={48}
                      style={{ margin: '0 auto', marginBottom: 8 }}
                    />
                    <p>PDF Documents</p>
                  </Grid.Column>
                  <Grid.Column>
                    <FileXls
                      size={48}
                      style={{ margin: '0 auto', marginBottom: 8 }}
                    />
                    <p>Excel/CSV Files</p>
                  </Grid.Column>
                  <Grid.Column>
                    <FileImage
                      size={48}
                      style={{ margin: '0 auto', marginBottom: 8 }}
                    />
                    <p>Images</p>
                  </Grid.Column>
                  <Grid.Column>
                    <FileText
                      size={48}
                      style={{ margin: '0 auto', marginBottom: 8 }}
                    />
                    <p>Text Files</p>
                  </Grid.Column>
                </Grid>

                <Form style={{ marginTop: 20 }}>
                  <Form.Field>
                    <label
                      htmlFor="file-upload"
                      style={{ cursor: 'pointer', textAlign: 'center' }}
                    >
                      <Button
                        as="div"
                        color="grey"
                        style={{ textAlign: 'center' }}
                      >
                        <Icon name="upload" />
                        Choose File
                      </Button>
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept=".pdf,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.txt"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                  </Form.Field>
                  {importFile && (
                    <Message info>
                      <Message.Header>Selected File</Message.Header>
                      <p>
                        {getFileIcon(importFile.name)} {importFile.name} (
                        {(importFile.size / 1024 / 1024).toFixed(2)} MB)
                      </p>
                    </Message>
                  )}

                  {importFile && (
                    <Form.Field>
                      <label>Additional Context (Optional)</label>
                      <Form.TextArea
                        placeholder="Provide any additional context to help interpret the document. For example: 'This is a steel catalog focusing on W-shapes' or 'Extract only lumber products, ignore hardware'..."
                        value={importContext}
                        onChange={(e) => setImportContext(e.target.value)}
                        rows={3}
                        style={{ width: '100%' }}
                      />
                      <small
                        style={{
                          color: '#666',
                          display: 'block',
                          marginTo: 5,
                        }}
                      >
                        This helps the AI better understand what to look for in
                        your document
                      </small>
                    </Form.Field>
                  )}
                </Form>
              </Segment>

              {importError && (
                <Message negative>
                  <Message.Header>Error</Message.Header>
                  <p>{importError}</p>
                </Message>
              )}
            </>
          )}

          {importPreview && !importSuccess && (
            <>
              <Message positive>
                <Message.Header>AI Extraction Preview</Message.Header>
                <p>
                  Found {importPreview.products_found} products in{' '}
                  {importPreview.file_name}
                </p>
                {importPreview.validation_score && (
                  <p>Validation Score: {importPreview.validation_score}%</p>
                )}
              </Message>

              {validationStep === 'feedback' && validationFeedback && (
                <Segment
                  color={
                    validationFeedback.validation_score >= 80
                      ? 'green'
                      : 'orange'
                  }
                >
                  <Header as="h3">
                    <Icon name="check circle" />
                    Validation Results (Score:{' '}
                    {validationFeedback.validation_score}%)
                  </Header>

                  {validationFeedback.issues &&
                    validationFeedback.issues.length > 0 && (
                      <>
                        <Header as="h4">Issues Found:</Header>
                        <Message warning>
                          <Message.List>
                            {validationFeedback.issues.map((issue, idx) => (
                              <Message.Item key={idx}>{issue}</Message.Item>
                            ))}
                          </Message.List>
                        </Message>
                      </>
                    )}

                  {validationFeedback.suggestions &&
                    validationFeedback.suggestions.length > 0 && (
                      <>
                        <Header as="h4">Suggestions:</Header>
                        <Message info>
                          <Message.List>
                            {validationFeedback.suggestions.map(
                              (suggestion, idx) => (
                                <Message.Item key={idx}>
                                  {suggestion}
                                </Message.Item>
                              )
                            )}
                          </Message.List>
                        </Message>
                      </>
                    )}

                  {validationFeedback.missing_products &&
                    validationFeedback.missing_products.length > 0 && (
                      <>
                        <Header as="h4">Potentially Missing Products:</Header>
                        <Message>
                          <Message.List>
                            {validationFeedback.missing_products.map(
                              (product, idx) => (
                                <Message.Item key={idx}>{product}</Message.Item>
                              )
                            )}
                          </Message.List>
                        </Message>
                      </>
                    )}

                  <Button.Group style={{ marginTop: 20 }}>
                    <Button
                      onClick={() => {
                        setValidationStep(null)
                        setValidationFeedback(null)
                      }}
                    >
                      Continue Without Improving
                    </Button>
                    <Button.Or />
                    <Button
                      primary
                      onClick={handleImproveExtraction}
                      loading={validationStep === 'improving'}
                    >
                      <Icon name="magic" />
                      Improve Extraction
                    </Button>
                  </Button.Group>
                </Segment>
              )}

              <Header as="h3">Extraction Summary</Header>
              <Table celled>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <strong>Total Products</strong>
                    </Table.Cell>
                    <Table.Cell>
                      {importPreview.summary?.total_products || 0}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <strong>Commodities</strong>
                    </Table.Cell>
                    <Table.Cell>
                      {importPreview.summary?.commodities?.join(', ') || 'None'}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <strong>Materials</strong>
                    </Table.Cell>
                    <Table.Cell>
                      {importPreview.summary?.materials?.join(', ') || 'None'}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <strong>Total Attributes</strong>
                    </Table.Cell>
                    <Table.Cell>
                      {importPreview.summary?.total_attributes || 0}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <strong>Total Attribute Values</strong>
                    </Table.Cell>
                    <Table.Cell>
                      {importPreview.summary?.total_selections || 0}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>

              <Header as="h3">Extracted Products</Header>
              <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                {importPreview.products?.map((product, index) => (
                  <Segment key={index}>
                    <Header as="h4">
                      Product {index + 1}: {product.commodity_name} -{' '}
                      {product.material_name}
                    </Header>
                    <p>
                      <strong>Form:</strong>{' '}
                      {product.commodity_form_name || 'Standard'}
                    </p>
                    <p>
                      <strong>Unit:</strong> {product.unit_name || 'Each'} (
                      {product.unit_abbrev || ''})
                    </p>

                    {product.attributes &&
                      Object.keys(product.attributes).length > 0 && (
                        <>
                          <Header as="h5">Attributes:</Header>
                          {Object.entries(product.attributes).map(
                            ([attrName, attrValues]) => (
                              <div key={attrName} style={{ marginBottom: 10 }}>
                                <strong>{attrName}:</strong>{' '}
                                {Array.isArray(attrValues) ? (
                                  attrValues.map((value, idx) => (
                                    <Label
                                      key={idx}
                                      size="small"
                                      style={{ margin: 2 }}
                                    >
                                      {value}
                                    </Label>
                                  ))
                                ) : (
                                  <Label size="small">{attrValues}</Label>
                                )}
                              </div>
                            )
                          )}
                        </>
                      )}
                  </Segment>
                ))}
              </div>

              {importError && (
                <Message negative>
                  <Message.Header>Error</Message.Header>
                  <p>{importError}</p>
                </Message>
              )}
            </>
          )}

          {importSuccess && (
            <Message success>
              <Message.Header>Import Successful!</Message.Header>
              <p>
                Created {importSuccess.products_created} products, Updated{' '}
                {importSuccess.products_updated} products, Created{' '}
                {importSuccess.attributes_created} attributes, Created{' '}
                {importSuccess.selections_created} selections.
              </p>
            </Message>
          )}
        </Modal.Content>
        <Modal.Actions>
          {!importPreview && !importSuccess && (
            <>
              <Button onClick={() => setOpenImportModal(false)}>Cancel</Button>
              <Button
                primary
                style={{
                  '--primaryColor': tenant?.deployment_primary_color,
                  '--secondaryButtonColor':
                    env.REACT_APP_SECONDARY_BUTTON_COLOR,
                }}
                onClick={handleImportPreview}
                disabled={!importFile || importLoading}
                loading={importLoading}
              >
                <Icon name="eye" />
                Preview AI Extraction
              </Button>
            </>
          )}

          {importPreview && !importSuccess && (
            <>
              <Button
                onClick={() => {
                  setImportPreview(null)
                  setImportFile(null)
                  setValidationStep(null)
                  setValidationFeedback(null)
                }}
                disabled={importLoading}
              >
                Back
              </Button>
              {!validationStep && (
                <>
                  <Button
                    secondary
                    onClick={handleValidateProducts}
                    disabled={importLoading}
                    loading={importLoading && validationStep === 'validating'}
                  >
                    <Icon name="check circle" />
                    Validate Extraction
                  </Button>
                  <Button
                    primary
                    onClick={handleImportConfirm}
                    disabled={importLoading}
                    loading={importLoading && !validationStep}
                  >
                    <Icon name="check" />
                    Confirm Import
                  </Button>
                </>
              )}
            </>
          )}

          {importSuccess && (
            <Button primary onClick={() => setOpenImportModal(false)}>
              Close
            </Button>
          )}
        </Modal.Actions>
      </Modal>
    </>
  )
}

export default AdminProducts
